import { render, staticRenderFns } from "./LinhaTotalizadora.vue?vue&type=template&id=11925971&scoped=true"
import script from "./LinhaTotalizadora.vue?vue&type=script&lang=js"
export * from "./LinhaTotalizadora.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11925971",
  null
  
)

export default component.exports